import EmptySearchImage from "@/assets/images/empty-search.svg?react";
import { EmptyContainer, EmptyText } from "@/components/styling/empty";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { logger } from "@/modules/logger";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";

export enum EntityNotFoundType {
  Note = "note",
  Collection = "collection",
  Template = "template",
}

export interface NotFoundPageProps {
  entityType?: EntityNotFoundType;
  withBackButton?: () => void;
}

export const NotFoundPage = observer<NotFoundPageProps>(function NotFound({ entityType }) {
  const location = useLocation();
  useEffectOnMount(() => {
    logger.warn({
      message: `[NotFoundPage] ${entityType ?? "unknown type"} at ${location.pathname}${location.search}${location.hash}`,
    });
  });

  return (
    <EmptyContainer>
      <EmptySearchImage />
      <EmptyText>
        {entityType && `This ${entityType} doesn’t exist`}
        {!entityType && `Not found`}
      </EmptyText>
    </EmptyContainer>
  );
});
